/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { isEmpty } from 'lodash';

// Components
import BaseControl from './BaseControl.vue';
import BaseInput from 'shared/ui/components/form-components/BaseInput.vue';
import NestedFormModal from 'shared/ui/components/form-components/NestedFormModal.vue';

const __vue_script__ = {
    name: 'MetaList',

    components: { BaseInput },

    extends: BaseControl,

    props: {
        event: {
            type: Object,
            default: () => ({})
        },

        value: {
            type: Array,
            default: () => []
        },

        fields: {
            type: [Object, Array],
            default: () => []
        },

        itemType: {
            type: String,
            default: 'text'
        }
    },

    data() {
        let nestedFields = [];
        if (this.fields instanceof Array) {
            nestedFields = this.fields;
        } else {
            for (const fieldName of Object.keys(this.fields)) {
                const fieldDescriptor = this.fields[fieldName];
                fieldDescriptor.field = fieldName;
                nestedFields.push(fieldDescriptor);
            }
        }

        return {
            editing: null,
            focusedIndex: null,
            itemValue: {},
            nestedFields,
        };
    },

    computed: {
        innerValue: {
            get() {
                return this.value || this.$utils.collections.createObservableArray({ target: [], listener: this.mutationObserver.bind(this) });
            },

            set(value) {
                this.$emit('input', value);
            }
        }
    },

    beforeDestroy() {
        this.editing = null;
        this.itemValue = {};
    },

    methods: {
        itemTitle(item) {
            for (const field of this.nestedFields) {
                if (field.kind === 'text' && !isEmpty(item[field.field])) {
                    return item[field.field];
                }
            }

            return this.$i18n.t('generic_form.contextual.list.item');
        },

        addItem() {
            if (this.itemType === 'nested-object') {
                this.showModal();
            } else if (this.innerValue.find((item) => item === '') === undefined) {
                this.innerValue.push('');
            }
            this.focusedIndex = this.innerValue.length - 1;
        },

        editItem(item, index) {
            if (this.itemType === 'nested-object') {
                this.editing = index;
                this.itemValue = item;
                this.showModal();
            }
        },

        showModal() {
            this.$modal.show(NestedFormModal, {
                label: this.label,
                itemValue: this.itemValue,
                nestedFields: this.nestedFields,
                event: this.event,
                editing: this.editing,
                save: this.save.bind(this)
            }, {
                classes: 'small',
                height: 'auto',
                reset: true
            });
        },

        removeItem(index) {
            this.innerValue.splice(index, 1);
        },

        save(value) {
            if (this.editing !== null) {
                this.innerValue[this.editing] = value;
            } else {
                this.innerValue.push(value);
            }

            this.editing = null;
            this.itemValue = {};
        },

        mutationObserver({ target }) {
            this.$emit('input', target);
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "control-decorator",
    {
      staticClass: "metalist",
      attrs: {
        label: _vm.label,
        tip: _vm.tip,
        hint: _vm.hint,
        errors: _vm.errors,
        uid: _vm.uid,
        "hint-after-label": true,
        dependant: _vm.dependant,
      },
    },
    [
      _c(
        "div",
        { staticClass: "elements" },
        _vm._l(_vm.innerValue, function (item, i) {
          return _c(
            "div",
            { key: "item-" + i, staticClass: "element" },
            [
              _vm.itemType === "checkbox"
                ? [
                    _c("div", { staticClass: "alert alert-error" }, [
                      _c("p", [
                        _vm._v(
                          "Not implemented yet. Find me in apps/shared/src/ui/components/form-components/MetaList.vue"
                        ),
                      ]),
                    ]),
                  ]
                : _vm.itemType === "choice-list"
                ? [
                    _c("div", { staticClass: "alert alert-error" }, [
                      _c("p", [
                        _vm._v(
                          "Not implemented yet. Find me in apps/shared/src/ui/components/form-components/MetaList.vue"
                        ),
                      ]),
                    ]),
                  ]
                : _vm.itemType === "nested-object"
                ? [
                    _c(
                      "button",
                      {
                        staticClass: "btn important descriptor",
                        attrs: { type: "button", disabled: _vm.disabled },
                        on: {
                          click: function ($event) {
                            return _vm.editItem(item, i)
                          },
                        },
                      },
                      [
                        _c(
                          "i18n",
                          {
                            attrs: {
                              path: "generic_form.contextual.list.edit",
                            },
                          },
                          [_c("strong", [_vm._v(_vm._s(_vm.itemTitle(item)))])]
                        ),
                      ],
                      1
                    ),
                  ]
                : [
                    _c("base-input", {
                      attrs: {
                        name: "list-item-" + i + "-" + _vm.uid,
                        disabled: _vm.disabled,
                        errors: _vm.errors,
                        focused: _vm.focusedIndex === i,
                      },
                      on: {
                        keydown: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          $event.preventDefault()
                          return _vm.addItem.apply(null, arguments)
                        },
                        focused: function ($event) {
                          _vm.focusedIndex = null
                        },
                        blur: function ($event) {
                          _vm.focusedIndex = null
                        },
                      },
                      model: {
                        value: _vm.innerValue[i],
                        callback: function ($$v) {
                          _vm.$set(_vm.innerValue, i, $$v)
                        },
                        expression: "innerValue[i]",
                      },
                    }),
                  ],
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: _vm.$t("generic_form.contextual.list.remove"),
                      expression: "$t('generic_form.contextual.list.remove')",
                    },
                  ],
                  staticClass: "btn btn-danger btn-icon single remove",
                  attrs: { type: "button", disabled: _vm.disabled },
                  on: {
                    click: function ($event) {
                      return _vm.removeItem(i)
                    },
                  },
                },
                [_c("i", { staticClass: "ic-trash-2" })]
              ),
            ],
            2
          )
        }),
        0
      ),
      _c(
        "button",
        {
          directives: [
            {
              name: "tooltip",
              rawName: "v-tooltip",
              value: _vm.$t("generic_form.contextual.list.add"),
              expression: "$t('generic_form.contextual.list.add')",
            },
          ],
          staticClass: "btn single btn-icon",
          attrs: { type: "button", disabled: _vm.disabled },
          on: { click: _vm.addItem },
        },
        [_c("i", { staticClass: "ic-plus" })]
      ),
    ]
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/shared/src/ui/components/form-components/MetaList.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__